export const getColumnPadding = (listLength) => {
    switch (listLength) {
        case 4:
            return 'xl:pl-[50px] xl:pr-[50px] xl:pb-[40px] xl:pt-[30px] pl-[40px] pr-[40px] pb-[40px] pt-[30px]';
        case 2:
        case 3:
        default:
            return 'xl:pl-[70px] xl:pr-[70px] xl:pb-[40px] xl:pt-[30px] pl-[40px] pr-[40px] pb-[40px] pt-[30px]';
    }
};
